// Firebase dead-code stub (firebase/auth). Supabase is the live path.
export type Auth = any;
export type User = any;
export type UserCredential = any;
export async function signInWithCustomToken(..._args: any[]): Promise<any> {
  return { user: null } as any;
}
export async function signOut(..._args: any[]): Promise<void> { return; }
export function onAuthStateChanged(..._args: any[]): () => void { return () => {}; }
export function getAuth(..._args: any[]): any { return null as any; }
